import { Component, Input } from '@angular/core';

@Component({
  selector: 'broker-phone-svg',
  templateUrl: './phone-svg.component.svg'
})
export class PhoneSvgComponent {
  @Input() cssClasses: string;
}
